<template>
  <v-row
    no-gutters
    dense
  >
    <v-col cols="12">
      <v-card
        outlined
      >
        <v-card-text>
          <v-row no-gutters dense>
            <v-col cols="12">
              <div class="subtitle-2 mb-1">Payment Method</div>
              <v-radio-group
                v-model="paymentMethod"
                :disabled="loading"
                row
                class="mt-0"
              >
                <v-radio
                  v-for="method in paymentMethods"
                  :key="method.value"
                  :label="method.text"
                  :value="method.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-form ref="form">
            <v-row no-gutters dense>
              <v-col cols="2" >
                <v-text-field label="Amount"
                              :rules="[rules.required]"
                              :disabled="loading"
                              v-model="amount"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters dense v-if="paymentMethod == 1">
              <v-col cols="2" >
                <v-text-field label="Bank"
                              :rules="[rules.required]"
                              v-model="bank"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Reference No"
                              :rules="[rules.required]"
                              v-model="referenceNo"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Transfer Datetime"
                              :rules="[rules.required]"
                              v-model="transferDatetime"
                              @click.prevent="openDatetimePicker($event)"
                              :readonly="true"
                ></v-text-field>
                <datetime
                  class="datetime-picker"
                  ref="datetimePicker"
                  type="datetime"
                  v-model="pickerTransferDatetime"
                  :hour-step="1"
                  :minute-step="5"
                  format="yyyy-MM-dd HH:mm:ss"
                  auto
                ></datetime>
              </v-col>
            </v-row>
            <div v-if="paymentMethod == 3">
              <v-radio-group v-model="stripePaymentMode">
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <stripe-saved-cards
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      v-on:remove-card="hasSavedCard = false"
                    ></stripe-saved-cards>
                  </v-col>
                </v-row>
                <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="12" md="6">
                    <stripe-payment
                      :amount="amount"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></stripe-payment>
                  </v-col>
                </v-row>
                <v-row no-gutters dense v-if="!airwallexAvailable">
                  <v-col cols="12">
                    <v-checkbox
                      v-if="$store.state.brand === 'cldy'"
                      label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                    <v-checkbox
                      v-else
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
            <div v-if="[7, 8].includes(paymentMethod)">
              <v-radio-group
                v-model="airwallexPaymentMode"
                :disabled="loading || airwallexSavedCardsBusy"
              >
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <airwallex-saved-cards v-if="!airwallexWalletSelected"
                      ref="airwallexSavedCards"
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      :busy.sync="airwallexSavedCardsBusy"
                      :disabled="loading"
                      v-on:remove-card="hasSavedCard = false"
                    ></airwallex-saved-cards>
                  </v-col>
                </v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="12" md="6">
                    <airwallex-payment
                      :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                      @apple-pay-selected="selectAirwallexApplePay"
                      :amount="amount"
                      :invalid.sync="creditCardInvalid"
                      :disabled="loading || airwallexSavedCardsBusy"
                      @interface="getAirwallexInterface"
                    ></airwallex-payment>
                  </v-col>
                </v-row>
                <v-row
                  v-if="airwallexWalletSelected || !hasSavedCard
                    || airwallexPaymentMode === 'useNewCard'"
                  no-gutters
                  dense
                >
                  <v-col cols="12">
                    <v-checkbox
                      v-if="$store.state.brand === 'cldy'"
                      label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                      :disabled="loading || airwallexSavedCardsBusy || airwallexWalletSelected"
                    ></v-checkbox>
                    <v-checkbox
                      v-else
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                      :disabled="loading || airwallexSavedCardsBusy || airwallexWalletSelected"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-form>
          <v-row no-gutters dense>
            <v-col cols="12" class="text-right">
              <v-tooltip bottom
                v-if="[7, 8].includes(paymentMethod) && airwallexPaymentMode !== 'useSavedCard'"
              >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="success"
                      :loading="loading"
                      :disabled="(loading
                        || airwallexSavedCardsBusy
                        || creditCardInvalid !== false
                        || !airwallexInterfaceReady) || airwallexWalletSelected"
                      v-bind="attrs"
                      v-on="on"
                      @click="saveCard">
                      Save Card Only
                    </v-btn>
                    <span>&nbsp;Or&nbsp;</span>
                </template>
                <span>
                  Your card will be verified for future payments. Complete 3D Secure if prompted;
                  no $5 payment will be taken.
                </span>
              </v-tooltip>
              <v-btn
                v-if="[7, 8].includes(paymentMethod)"
                color="primary"
                :loading="loading"
                :disabled="airwallexSavedCardsBusy"
                @click="submit"
              >
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Topup Now (Visa/Master)' }}
                </v-btn>
              <v-btn
                v-else
                color="primary"
                :loading="loading"
                :disabled="airwallexSavedCardsBusy"
                @click="submit"
              >Submit</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { DateTime } from 'luxon';
import airwallexWallet from '../../../mixins/airwallex-wallet';
import {
  StripePayment, StripeSavedCards, AirwallexPayment, AirwallexSavedCards,
} from '../../components/payment_modules';
import {
  airwallexCustomerErrorMessage,
  clearAirwallexDirectTopup,
  creditCardPaymentSupportReferenceSuffix,
  creditCardPaymentMethodLabel,
  getAirwallexDirectTopup,
  getOrCreateAirwallexDirectTopup,
  isAirwallexTerminalRequestError,
  isValidAirwallexTopupAmount,
  pollAirwallexPayment,
  saveAirwallexCardConsent,
  saveAirwallexDirectTopup,
  toCreditCardPaymentMessage,
  validateAirwallexDirectTopupResponse,
} from '../../../plugins/airwallex-payment';
import {
  resolveAirwallexPaymentIntentId,
} from '../../../mixins/airwallex-recovery';

export default {
  mixins: [airwallexWallet],
  name: 'Topup',
  components: {
    StripeSavedCards,
    StripePayment,
    AirwallexPayment,
    AirwallexSavedCards,
  },
  data() {
    return {
      bank: '',
      referenceNo: '',
      transferDatetime: null,
      pickerTransferDatetime: null,
      paymentMethod: 3,
      paymentMethods: [],
      paypalOrderId: '',
      amount: '',
      loading: false,
      saveAsDefaultCard: false,
      creditCardInvalid: null,
      creditCard: null,
      savedCard: null,
      hasSavedCard: false,
      airwallexSavedCardsBusy: false,
      airwallexInterfaceReady: false,
      stripePaymentMode: 'useNewCard',
      airwallexPaymentMode: 'useNewCard',
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
    };
  },
  created() {
    this.transferDatetime = DateTime.local().toFormat('yyyy-MM-dd HH:mm:ss');
    this.pickerTransferDatetime = DateTime.local().toISO();
    this.$api.get('partner/payment-methods').then((response) => {
      const paymentMethods = this.filterWalletPaymentMethods(response.data).map((method) => ({
        ...method,
        text: creditCardPaymentMethodLabel(method),
      }));

      this.$set(this, 'paymentMethods', paymentMethods);

      // The default method (Stripe) is hidden for Airwallex-stage
      // customers; fall back to Airwallex, or the first available method.
      const methodIds = paymentMethods.map((method) => method.id);
      if (methodIds.length && !methodIds.includes(this.paymentMethod)) {
        this.paymentMethod = methodIds.includes(7) ? 7 : methodIds[0];
      }
    });
  },
  computed: {
    airwallexAvailable() {
      return this.paymentMethods.some((paymentMethod) => paymentMethod.id === 7);
    },
  },
  methods: {
    getAirwallexInterface(childInterface) {
      const ready = !!childInterface
        && typeof childInterface.confirmIntent === 'function'
        && typeof childInterface.createConsent === 'function';

      this.$options.airwallexInterface = ready ? childInterface : null;
      this.airwallexInterfaceReady = ready;
    },
    async saveNewAirwallexCardAsDefault() {
      if (this.creditCardInvalid !== false
        || !this.airwallexInterfaceReady
      ) {
        throw new Error('The credit card payment form is not ready.');
      }

      await saveAirwallexCardConsent(
        this.$api,
        this.$options.airwallexInterface,
      );

      const savedCardResponse = await this.$api.get(
        'partner/payment/get-saved-cards',
        { suppressErrorAlert: true },
      );
      const savedAirwallexCard = savedCardResponse.data;

      if (!savedAirwallexCard || Number(savedAirwallexCard.payment_type_id) !== 7) {
        throw new Error('The saved credit card could not be loaded.');
      }

      this.$set(this, 'savedCard', savedAirwallexCard);
      this.$set(this, 'hasSavedCard', true);
      this.$set(this, 'airwallexPaymentMode', 'useSavedCard');

      if (this.$refs.airwallexSavedCards) {
        this.$refs.airwallexSavedCards.applySavedCard(savedAirwallexCard);
      }
    },
    getAirwallexDirectTopupContext(mode) {
      const paymentMode = Number(this.paymentMethod) === 8 ? 'apple_pay' : mode;
      const user = this.$store.state.user || {};
      const userSettings = user.user_settings || {};
      const { brand } = this.$store.state;

      return {
        brand,
        currency: window.systemCurrency,
        environment: process.env.VUE_APP_AIRWALLEX_ENV,
        accountScope: brand === 'cldy' ? 'cldy' : 'gce',
        userId: user.id || userSettings.userId || null,
        mode: paymentMode,
        cardId: mode === 'saved' && this.savedCard ? this.savedCard.id : null,
        amount: this.amount,
      };
    },
    completeAirwallexDirectTopup(response, context, operation) {
      const validatedResponse = validateAirwallexDirectTopupResponse(
        response,
        'completion',
        operation.payment_intent_id,
      );
      const resolvedOperation = {
        ...operation,
        payment_intent_id: validatedResponse.paymentIntentId,
        support_reference: validatedResponse.supportReference
          || operation.support_reference
          || null,
        browser_confirmed: true,
      };

      if (validatedResponse.pending) {
        const pendingOperation = saveAirwallexDirectTopup(
          context,
          resolvedOperation,
        );

        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'info',
          message: [
            'Your top-up is still processing. ',
            'The same payment will be reconciled automatically.',
            creditCardPaymentSupportReferenceSuffix(
              pendingOperation.support_reference,
            ),
          ].join(''),
        });
        return pendingOperation;
      }

      const recoveryCleared = clearAirwallexDirectTopup(
        context,
        resolvedOperation,
      );
      const alreadyCompleted = validatedResponse.alreadyCompleted === true;
      let completionMessage = alreadyCompleted
        ? 'This top-up was already completed. No new charge was made.'
        : 'Your payment is submitted successfully.';

      if (!recoveryCleared) {
        completionMessage += ' Enable browser storage before starting another top-up.';
      }

      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: alreadyCompleted ? 'info' : 'success',
        message: completionMessage,
      });
      this.reset();
      return resolvedOperation;
    },
    handleAirwallexDirectTopupError(error, context, operation = null) {
      let alertError = error;
      const terminalRequestError = isAirwallexTerminalRequestError(error);
      const reconciliationGuidance = !terminalRequestError && operation
        ? ` The same payment will be reconciled when you retry.${
          creditCardPaymentSupportReferenceSuffix(
            operation.support_reference,
          )
        }`
        : ' Please retry again.';

      if (!(error && error.retainAirwallexOperation)
        && terminalRequestError) {
        try {
          if (operation && operation.payment_intent_id) {
            saveAirwallexDirectTopup(context, {
              payment_operation_id: operation.payment_operation_id,
              payment_intent_id: null,
              browser_confirmed: false,
            });
          } else {
            clearAirwallexDirectTopup(context);
          }
        } catch (storageError) {
          alertError = storageError;
        }
      }

      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'error',
        message: `An error occurred ${
          toCreditCardPaymentMessage((alertError && alertError.message) || '')
        }.${reconciliationGuidance}`,
      });
    },
    submitWithSavedAirwallexCard() {
      const context = this.getAirwallexDirectTopupContext('saved');
      let operation;

      try {
        operation = getOrCreateAirwallexDirectTopup(context);
      } catch (error) {
        this.handleAirwallexDirectTopupError(error, context);
        this.loading = false;
        return Promise.resolve();
      }

      const capturePayment = () => this.$api.post('partner/payment', {
        payment_type_id: Number(this.paymentMethod),
        capture: 1,
        id: operation.payment_intent_id,
      });
      let paymentRequest;

      if (operation.payment_intent_id) {
        paymentRequest = pollAirwallexPayment(capturePayment);
      } else {
        paymentRequest = this.$api.post('partner/payment/use-saved-card', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.amount,
          payment_card_id: this.savedCard.id,
          payment_operation_id: operation.payment_operation_id,
        }).then((response) => {
          const validatedResponse = validateAirwallexDirectTopupResponse(
            response,
            'completion',
          );
          const paymentIntentId = resolveAirwallexPaymentIntentId(
            validatedResponse.paymentIntentId,
            null,
            operation.payment_intent_id,
          );

          const resolvedOperation = {
            ...operation,
            payment_intent_id: paymentIntentId,
            support_reference: validatedResponse.supportReference
              || operation.support_reference
              || null,
            browser_confirmed: true,
          };

          if (!validatedResponse.pending) {
            operation = resolvedOperation;
            return response;
          }

          operation = saveAirwallexDirectTopup(
            context,
            resolvedOperation,
          );
          return pollAirwallexPayment(capturePayment, response);
        });
      }

      return paymentRequest
        .then((response) => {
          operation = this.completeAirwallexDirectTopup(
            response,
            context,
            operation,
          );
        })
        .catch((error) => {
          this.handleAirwallexDirectTopupError(error, context, operation);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitWithNewAirwallexCard() {
      const context = this.getAirwallexDirectTopupContext('new');
      let operation;

      try {
        operation = getOrCreateAirwallexDirectTopup(context);
      } catch (error) {
        this.handleAirwallexDirectTopupError(error, context);
        this.loading = false;
        return Promise.resolve();
      }

      const capturePayment = () => this.$api.post('partner/payment', {
        payment_type_id: Number(this.paymentMethod),
        capture: 1,
        id: operation.payment_intent_id,
      });
      let paymentRequest;

      if (operation.payment_intent_id && operation.browser_confirmed) {
        paymentRequest = pollAirwallexPayment(capturePayment);
      } else {
        paymentRequest = this.$api.post('partner/payment', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.amount,
          payment_operation_id: operation.payment_operation_id,
        }).then((response) => {
          const validatedResponse = validateAirwallexDirectTopupResponse(
            response,
            'authorization',
          );
          const paymentIntentId = resolveAirwallexPaymentIntentId(
            validatedResponse.paymentIntentId,
            null,
            operation.payment_intent_id,
          );

          operation = saveAirwallexDirectTopup(context, {
            ...operation,
            payment_intent_id: paymentIntentId,
            support_reference: validatedResponse.supportReference
              || operation.support_reference
              || null,
          });

          if (validatedResponse.pending) {
            operation = saveAirwallexDirectTopup(context, {
              ...operation,
              browser_confirmed: true,
            });

            return pollAirwallexPayment(capturePayment, response);
          }

          return this.$options.airwallexInterface.confirmIntent(
            operation.payment_intent_id,
            validatedResponse.clientSecret,
          ).catch((error) => {
            const confirmationError = new Error(
              (error && error.message) || 'Card confirmation failed.',
            );
            confirmationError.retainAirwallexOperation = true;
            throw confirmationError;
          }).then(() => {
            operation = saveAirwallexDirectTopup(context, {
              ...operation,
              browser_confirmed: true,
            });

            return pollAirwallexPayment(capturePayment);
          });
        });
      }

      return paymentRequest
        .then((response) => {
          operation = this.completeAirwallexDirectTopup(
            response,
            context,
            operation,
          );
        })
        .catch((error) => {
          this.handleAirwallexDirectTopupError(error, context, operation);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async saveCard() {
      if (this.loading
        || this.airwallexWalletSelected
        || this.airwallexSavedCardsBusy
        || this.creditCardInvalid !== false
        || !this.airwallexInterfaceReady
      ) {
        return false;
      }

      this.loading = true;
      try {
        await saveAirwallexCardConsent(
          this.$api,
          this.$options.airwallexInterface,
        );
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Your card is saved successfully.',
        });
        this.reset();
        return true;
      } catch (error) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: airwallexCustomerErrorMessage(
            error,
            'The card could not be saved. Please try again.',
          ),
        });
        return false;
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      if (this.loading || this.airwallexSavedCardsBusy) {
        return;
      }

      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }

      if ([7, 8].includes(this.paymentMethod) && !isValidAirwallexTopupAmount(this.amount)) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'Enter a valid top-up amount with no more than two decimal places.',
        });
        this.loading = false;
        return;
      }

      const pendingNewAirwallexContext = this.getAirwallexDirectTopupContext('new');
      const pendingNewAirwallexOperation = [7, 8].includes(this.paymentMethod)
        ? getAirwallexDirectTopup(pendingNewAirwallexContext)
        : null;

      if ([7, 8].includes(this.paymentMethod)
        && (!this.hasSavedCard || this.airwallexPaymentMode === 'useNewCard')
        && this.saveAsDefaultCard
        && !this.airwallexWalletSelected
        && !(pendingNewAirwallexOperation
          && pendingNewAirwallexOperation.payment_intent_id)
      ) {
        try {
          await this.saveNewAirwallexCardAsDefault();
        } catch (error) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: airwallexCustomerErrorMessage(
              error,
              'The card could not be saved. Please try again.',
            ),
          });
          this.loading = false;
          return;
        }
      }

      const usingSavedCard = this.hasSavedCard
        && ((this.paymentMethod === 3 && this.stripePaymentMode === 'useSavedCard')
          || (this.paymentMethod === 7 && this.airwallexPaymentMode === 'useSavedCard'));
      const newAirwallexContext = this.getAirwallexDirectTopupContext('new');
      const newAirwallexOperation = [7, 8].includes(this.paymentMethod) && !usingSavedCard
        ? getAirwallexDirectTopup(newAirwallexContext)
        : null;
      const resumingConfirmedAirwallexPayment = newAirwallexOperation
        && newAirwallexOperation.payment_intent_id
        && newAirwallexOperation.browser_confirmed;

      if ((this.paymentMethod === 3 || [7, 8].includes(this.paymentMethod))
        && !usingSavedCard && this.creditCardInvalid
        && !resumingConfirmedAirwallexPayment) {
        this.loading = false;
        return;
      }

      if (this.paymentMethod === 1) {
        this.$api.post('partner/payment', {
          payment_type_id: this.paymentMethod,
          bank: this.bank,
          reference_no: this.referenceNo,
          transfer_datetime: this.transferDatetime,
          amount: this.amount,
        })
          .then(() => {
            const successMessage = 'Your payment is submitted successfully. Admin will review and confirm the payment.';
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: successMessage,
            });
            this.reset();
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 3) {
        if (this.hasSavedCard && this.stripePaymentMode === 'useSavedCard') {
          this.$api.post('partner/payment/use-saved-card', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            payment_card_id: this.savedCard.id,
          })
            .then((response) => {
              const stripePaymentObj = {};

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                    return;
                  }

                  if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment', {
                      payment_type_id: this.paymentMethod,
                      capture: 1,
                      id: result.paymentIntent.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            });
        } else {
          this.$api.post('partner/payment', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            save_as_default_card: this.saveAsDefaultCard,
          })
            .then((response) => {
              const stripePaymentObj = {
                payment_method: {
                  card: this.creditCard,
                },
              };

              if (this.saveAsDefaultCard) {
                stripePaymentObj.setup_future_usage = 'off_session';
              }

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                    return;
                  }

                  if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment', {
                      payment_type_id: this.paymentMethod,
                      capture: 1,
                      id: result.paymentIntent.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            });
        }
      }

      if (this.paymentMethod === 7 && this.hasSavedCard
        && this.airwallexPaymentMode === 'useSavedCard') {
        // The saved card shown under Airwallex may live on another module
        // (PayPal/Stripe are hidden once Airwallex is active); charge it
        // through its own module.
        if (this.savedCard.payment_type_id === 4) {
          this.submitWithSavedPaypalCard();
        } else if (this.savedCard.payment_type_id === 3) {
          this.submitWithSavedStripeCard();
        } else {
          this.submitWithSavedAirwallexCard();
        }
      } else if ([7, 8].includes(this.paymentMethod)) {
        this.submitWithNewAirwallexCard();
      }
    },
    submitWithSavedPaypalCard() {
      this.$api.post('partner/payment/use-saved-card', {
        payment_type_id: 4,
        amount: this.amount,
        payment_card_id: this.savedCard.id,
      })
        .then((response) => {
          this.$set(this, 'paypalOrderId', response.data.order_id);
          this.$nextTick(() => {
            this.$api.post('partner/payment/use-saved-card', {
              payment_type_id: 4,
              amount: this.amount,
              payment_card_id: this.savedCard.id,
              save_as_default_card: false,
              confirm: 1,
              capture: 1,
              id: this.paypalOrderId,
            })
              .then(() => {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'success',
                  message: 'Your payment is submitted successfully.',
                });
                this.reset();
              })
              .catch((error) => {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: `An error occurred ${error.message}. Please retry again.`,
                });
                this.loading = false;
              });
          });
        })
        .catch((error) => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: `An error occurred ${error.message}. Please retry again.`,
          });
          this.loading = false;
        });
    },
    submitWithSavedStripeCard() {
      this.$api.post('partner/payment/use-saved-card', {
        payment_type_id: 3,
        amount: this.amount,
        payment_card_id: this.savedCard.id,
      })
        .then((response) => {
          window.stripeClient.confirmCardPayment(response.data.client_secret, {})
            .then(async (result) => {
              if (result.error) {
                await this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: result.error,
                });
                return;
              }

              if (result.paymentIntent.status === 'requires_capture') {
                await this.$api.post('partner/payment', {
                  payment_type_id: 3,
                  capture: 1,
                  id: result.paymentIntent.id,
                })
                  .then(() => {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'success',
                      message: 'Your payment is submitted successfully.',
                    });
                    this.reset();
                  });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset() {
      this.$router.push({
        path: '/refresh',
        query: {
          path: this.$route.fullPath,
        },
      });
    },
    openDatetimePicker(event) {
      this.$refs.datetimePicker.open(event);
    },
  },
  watch: {
    pickerTransferDatetime: {
      handler(newPickerTransferDatetime) {
        if (newPickerTransferDatetime !== null) {
          this.transferDatetime = DateTime.fromISO(newPickerTransferDatetime).toFormat('yyyy-MM-dd HH:mm:ss');
        }
      },
      deep: true,
    },
    hasSavedCard: {
      handler(hasSavedCard) {
        if (this.airwallexWalletSelected) {
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = false;
          return;
        }
        if (this.loading) {
          return;
        }

        if (hasSavedCard) {
          this.stripePaymentMode = 'useSavedCard';
          this.airwallexPaymentMode = 'useSavedCard';
        } else {
          this.stripePaymentMode = 'useNewCard';
          this.airwallexPaymentMode = 'useNewCard';
        }
      },
    },
  },
};
</script>
<style>
  .datetime-picker input {
    visibility: hidden !important;
  }
</style>
